const messages = {
  en: {
    home: {
      heroWelcome: 'Welcome to Your Vue.js App',
    },
  },
  es: {
    home: {
      heroWelcome: 'Crea tu tienda online y comience a vender !',
      heroDesc:
        'Hemos creado una herramienta que esta optimizada y enfocada directamente para generar ventas efectivas para su negocio.',
    },
  },
}

export default messages
